module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('idaho-map', {
    attrs: {
      "mapFile": "id.counties.json",
      "dataFile": "id_load.csv",
      "res": "Arrowrock",
      "resFile": "id.json",
      "whichState": "ID"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "ID"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "id.counties.json",
      "centersFile": "id_centers.json",
      "dataFile": "id-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d2ba00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Idaho.vue
// module id = 384
// module chunks = 1